module.exports = __webpack_public_path__ + "img/banner.a4421163.png";